import { render, staticRenderFns } from "./ActiveBox.vue?vue&type=template&id=35abfe52&scoped=true&"
import script from "./ActiveBox.vue?vue&type=script&lang=js&"
export * from "./ActiveBox.vue?vue&type=script&lang=js&"
import style0 from "./ActiveBox.vue?vue&type=style&index=0&id=35abfe52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35abfe52",
  null
  
)

export default component.exports